import { createSlice } from "@reduxjs/toolkit";
import { transactionType } from "constants/index";
import {
  cryptoBetPlace,
  getBetPlaceTransaction,
  getBetTransactionDetail,
  getCryptoCoins,
  updateBetDetail,
} from "redux-thunk/thunk/crypto.thunk";
import { generateCryptoPaymentToken, initiateCryptoWithdrawal } from "redux-thunk/thunk/payment.thunk";

const defaultCryptoState = {
  cryptoData: null,
  betLoader: false,
  betPlaceTransaction: [],
  activePlaceTransaction: [],
  closedPlaceTransaction: [],
  publicBetTransaction: [],
  betTransactionDetail: "",
  updateBet: "",
  cryptoCoinsList: [],
  showHowItWorksPopup: false,
  showRoiCalculator: false,
  showLimitModal: false,

  selectedCurrency: "CAD", // default selected currency
  token: null,
  transactionId: null,
  depositLoading: false,
  depositError: null,
  withdrawLoading: false,
  withdrawError: null,
  withdrawTransactionId: null,
};

const cryptoSlice = createSlice({
  name: "cryptoSlice",
  initialState: defaultCryptoState,
  reducers: {
    setShowHowItWorksPopup: (state, action) => ({
      ...state,
      showHowItWorksPopup: action.payload,
    }),
    setShowRoiCalculatorPopup: (state, action) => ({
      ...state,
      showRoiCalculator: action.payload,
    }),
    setShowLimitPopup: (state, action) => ({
      ...state,
      showLimitModal: action.payload,
    }),
    setPublicBetRemove: (state, action) => ({
      ...state,
      publicBetTransaction: action.payload,
    }),
    setActiveBetRemove: (state, action) => ({
      ...state,
      activePlaceTransaction: action.payload,
    }),
    setSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload;
    },
    clearPaymentCredentials: (state) => {
      state.token = null;
      state.transactionId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCryptoCoins.fulfilled, (state, action) => {
        state.cryptoCoinsList = action?.payload;
      })
      .addCase(cryptoBetPlace.fulfilled, (state, action) => {
        return {
          ...state,
          cryptoData: action.payload,
        };
      })
      .addCase(cryptoBetPlace.pending, (state, action) => {
        const { password, userNameOrEmail } = action.meta.arg;
        return {
          ...state,
          cryptoData: { password, userNameOrEmail },
        };
      })
      .addCase(updateBetDetail.fulfilled, (state, action) => {
        return {
          ...state,
          updateBet: action.payload,
        };
      })
      .addCase(getBetPlaceTransaction.pending, (state, action) => {
        return {
          ...state,
          betLoader: true,
        };
      })
      .addCase(getBetPlaceTransaction.fulfilled, (state, action) => {
        if (action.payload.name === transactionType.PUBLIC_BETS) {
          return {
            ...state,
            publicBetTransaction: action?.payload?.publicBets,
            betLoader: false,
          };
        } else if (action.payload.name === transactionType.ACTIVE_BETS) {
          return {
            ...state,
            activePlaceTransaction: action?.payload?.activeBets,
            betLoader: false,
          };
        } else if (action.payload.name === transactionType.CLOSED_BETS) {
          return {
            ...state,
            closedPlaceTransaction: action?.payload?.closedBets,
            betLoader: false,
          };
        } else {
          return {
            ...state,
            betPlaceTransaction: action?.payload?.leaderboard,
            betLoader: false,
          };
        }
      })
      .addCase(getBetTransactionDetail.fulfilled, (state, action) => {
        return {
          ...state,
          betTransactionDetail: action.payload,
        };
      })
      .addCase(generateCryptoPaymentToken.pending, (state) => {
        state.depositLoading = true;
        state.depositError = null;
      })
      .addCase(generateCryptoPaymentToken.fulfilled, (state, action) => {
        state.depositLoading = false;
        state.token = action.payload.token;
        state.transactionId = action.payload.transactionId;
      })
      .addCase(generateCryptoPaymentToken.rejected, (state, action) => {
        state.depositLoading = false;
        state.depositError = action.payload;
      })
      .addCase(initiateCryptoWithdrawal.pending, (state) => {
        state.withdrawLoading = true;
        state.withdrawError = null;
      })
      .addCase(initiateCryptoWithdrawal.fulfilled, (state, action) => {
        state.withdrawLoading = false;
        state.withdrawTransactionId = action.payload?.transactionId;
      })
      .addCase(initiateCryptoWithdrawal.rejected, (state, action) => {
        state.withdrawLoading = false;
        state.withdrawError = action.payload;
      });
  },
});

export const {
  setShowHowItWorksPopup,
  setShowRoiCalculatorPopup,
  setShowLimitPopup,
  setPublicBetRemove,
  setActiveBetRemove,
  setSelectedCurrency, // new
  clearPaymentCredentials, // new
} = cryptoSlice.actions;

export default cryptoSlice.reducer;
